import { useState } from 'react';
import Rcslider from './components/Rcslider';
import { Button } from 'antd';
import { forwardRef } from 'react'
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
const selectList = [{
    text: '脸部美化',
    icon: 'icon-faceBeautyOutlined',
    key: 'face'
}, {
    text: '身体美化',
    icon: 'icon-bodyBeautyOutlined',
    key: 'body'
}]

const AIBeauty = forwardRef((props, ref) => {
    const { initialized, nFace, AIEditLoading } = useContext(AIEditContext)
    const [segmentedKey, setSegmentedKey] = useState('face')
    return (
        <div className={styles.AIBeauty}>
            <div className={`${styles.AIBeautyContent} ${!props.url && styles.disabled}`}>
                <Button
                    disabled={!initialized}
                    style={{marginTop: '20px'}}
                    type="primary"
                    className={styles.createBtn}
                    onClick={props.oneClickBeauty}
                    >一键美化</Button>
                <div className={styles.magicEraseBar_btn}>
                    {
                        selectList.map((item) => {
                            return <div
                                key={item.key}
                                onClick={() => setSegmentedKey(item.key)}
                                className={`${styles.magicEraseBar_btn_}  ${segmentedKey == item.key ? styles.magicEraseBar_btn_selected : null}`}>
                                <Iconfont className={styles.Icon} type={item.icon} />
                                <p>{item.text}</p>
                            </div>
                        })
                    }
                </div>
                {
                    segmentedKey == 'face' ? <div >
                        {
                            props.faceArray?.map(item => (
                                <Rcslider
                                    disabled={!initialized || nFace == 0}
                                    key={item.name}
                                    value={item.value}
                                    getRcsliderValue={(value) => {
                                        props.saveUndoList(); 
                                        item.onChange(value)
                                    }}
                                    title={item.label}
                                    min={-100}
                                    max={100}></Rcslider>
                            ))
                        }
                    </div> : <div  >
                        {
                            props.bodyArray?.map(item => (
                                <Rcslider
                                    disabled={!initialized}
                                    key={item.name}
                                    value={item.value}
                                    getRcsliderValue={(value) => {
                                        props.saveUndoList(); 
                                        item.onChange(value)
                                    }}
                                    title={item.label}
                                    min={-100}
                                    max={100}></Rcslider>
                            ))
                        }
                    </div>
                }
                <Button
                    type="primary"
                    loading={AIEditLoading}
                    disabled={!initialized}
                    className={`${styles.createBtn} ${styles.createBtn2}`}
                    onClick={props.saveResult}
                >应用改动</Button>
            </div>
        </div>
    )
})

export default AIBeauty;
